// extracted by mini-css-extract-plugin
module.exports = {"toggleMenu":"_18xxW","settings":"_2DcY_","shown":"TGYVR","group":"_2aCeP","control":"_1_ApM","btnGroup":"V4WX7","selected":"_1MqhM"};